import Divider from '@mui/material/Divider';

import Stack from '~/common/components/Stacks/Stack';
import { Chip } from '~/common/mui/Chip';
import palette from '~/theme/mui/palette';

type TaxSummaryItemProps = {
  label: string;
  content: string | number;
  sx?: Pick<React.ComponentProps<typeof Stack>, 'sx'>;
  color?: 'info' | 'success';
  badge?: string;
};

export default function TaxSummaryItem({
  label,
  content,
  color,
  badge,
  sx = {},
  ...props
}: Readonly<TaxSummaryItemProps>) {
  return (
    <Stack
      sx={{
        width: '100%',
        ...sx,
      }}
      {...props}
    >
      <Stack
        sx={{
          flexDirection: 'row',
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 6,
        }}
      >
        <Stack sx={{ flexDirection: 'row', alignItems: 'center', gap: 3 }}>
          <Chip label={label} data-testid="tax-label-chip" />
          {badge && (
            <Chip
              label={badge}
              data-testid="tax-badge-chip"
              sx={{
                color: palette.black,
                backgroundColor: palette.blue[100],
              }}
            />
          )}
        </Stack>
        <Divider sx={{ flex: 1 }} />
        <Chip
          data-testid="tax-value-chip"
          label={content}
          color={color}
          sx={{
            fontWeight: '500',
            borderRadius: 8,
          }}
        />
      </Stack>
    </Stack>
  );
}
